<template>
  <h2>Página About</h2>
</template>

<script>
export default {

}
</script>

<style>

</style>